export default "__VITE_ASSET__DKf_jiuK__"